var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/emoji-button-wrapper.tsx";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable jsx-a11y/interactive-supports-focus */
import { Map as ImmutableMap } from 'immutable';
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { usePopper } from 'react-popper';
import { useDispatch } from 'react-redux';
import { simpleEmojiReact } from 'soapbox/actions/emoji_reacts';
import { openModal } from 'soapbox/actions/modals';
import EmojiSelector from 'soapbox/components/ui/emoji-selector/emoji-selector';
import { useAppSelector, useOwnAccount, useSoapboxConfig } from 'soapbox/hooks';
import { isUserTouching } from 'soapbox/is_mobile';
import { getReactForStatus } from 'soapbox/utils/emoji_reacts';
/** Provides emoji reaction functionality to the underlying button component */
const EmojiButtonWrapper = ({
  statusId,
  children
}) => {
  const root = React.useRef(null);
  const dispatch = useDispatch();
  const ownAccount = useOwnAccount();
  const status = useAppSelector(state => state.statuses.get(statusId));
  const meEmojiReact = getReactForStatus(status, null);
  const soapboxConfig = useSoapboxConfig();
  const [timer, setTimer] = useState(undefined);
  const [visible, setVisible] = useState(false);
  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const {
    styles,
    attributes
  } = usePopper(referenceElement, popperElement, {
    placement: 'top-start',
    modifiers: [{
      name: 'offset',
      options: {
        offset: [-10, 0]
      }
    }]
  });
  useEffect(() => {
    if (!timer) return undefined;
    const t = timer;
    return () => {
      clearTimeout(t);
    };
  }, [timer]);
  useEffect(() => {
    setReferenceElement(root.current);
  }, []);
  if (!status) return null;
  const handleMouseEnter = () => {
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
    if (!isUserTouching()) {
      setVisible(true);
    }
  };
  const handleMouseLeave = () => {
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }

    // Unless the user is touching, delay closing the emoji selector briefly
    // so the user can move the mouse diagonally to make a selection.
    if (isUserTouching()) {
      setVisible(false);
    } else {
      setTimer(setTimeout(() => setVisible(false), 500));
    }
  };
  const handleReact = emoji => {
    setVisible(false);
    if (!emoji) return;
    if (ownAccount) {
      dispatch(simpleEmojiReact(status, emoji));
    } else {
      dispatch(openModal('UNAUTHORIZED', {
        action: 'FAVOURITE',
        ap_id: status.url
      }));
    }
  };
  const handleClick = e => {
    e.preventDefault();
    e.stopPropagation();
    const wMeEmojiReact = getReactForStatus(status, soapboxConfig.allowedEmoji) || ImmutableMap({
      name: '👍'
    });
    if (isUserTouching()) {
      if (visible) {
        handleReact(wMeEmojiReact.get('name'));
      } else {
        setVisible(true);
      }
    } else {
      handleReact(wMeEmojiReact.get('name'));
    }
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React.createElement("div", {
      ref: root,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onClick: handleClick,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 122,
        columnNumber: 5
      }
    }, children, visible && (/*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement("div", _extends({
      className: "z-50 transition-opacity duration-100",
      ref: setPopperElement,
      style: styles.popper
    }, attributes.popper, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 127,
        columnNumber: 13
      }
    }), /*#__PURE__*/React.createElement(EmojiSelector, {
      meEmojiReact: meEmojiReact,
      emojis: soapboxConfig.allowedEmoji,
      onReact: handleReact,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 133,
        columnNumber: 15
      }
    })), document.body)))
  );
};
export default EmojiButtonWrapper;